
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10.333a.665.665 0 01-.471-.195L4.862 7.471a.666.666 0 11.943-.942l2.203 2.203 2.195-2.12a.667.667 0 01.927.96l-2.667 2.574a.665.665 0 01-.463.187z"}})])
          )
        }
      }
    